<template>
    <div class="relative z-40 xl:hidden" :class="{'hidden': !showUserMenu}" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-gray-600 bg-opacity-75"></div>
        <div class="fixed inset-0 flex z-40">
            <div class="relative flex-1 flex flex-col max-w-xs w-full bg-gray-800">
                <div class="absolute top-0 right-0 -mr-12 pt-2">
                    <button type="button"
                            @click="hideDropdownMenus()"
                            class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                        <span class="sr-only">{{$t('shared.mobile_menu.close_sidebar')}}</span>
                        <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
                    <div class="flex-shrink-0 flex items-center justify-between px-4 gap-x-2">
                        <Link href="/">
                          <logo class="fill-white" width="120" height="28" :image="this.$page.props.tenant.frontend.logo_file_white"/>
                        </Link>
                        <span class="text-white font-bold text-xl">AWA</span>
                    </div>

                    <nav class="mt-5 px-2 space-y-1">
                        <template v-for="(menuItem, index) in menu">
                            <Link v-if="menuItem.hasOwnProperty('route')"
                                  :key="index"
                                  :href="$route(menuItem.route)"
                                  v-on:click="navigateTo(menuItem.route)"
                                  class="text-white hover:bg-cyan-500 hover:text-white group flex items-center px-2 py-2 text-base font-medium"
                                  :class="{'pl-3' : menuItem.indent === 1, 'pl-6' : menuItem.indent === 2, 'text-white router-link-active' : isActive(menuItem.route)}"
                            >
                                <icon :name="menuItem.icon"
                                      class="w-4 h-4 mr-2"
                                      :class="menuIconClass(menuItem)" />
                                <span>{{menuItem.label}}</span>
                            </Link>
                            <span v-if="!menuItem.route" clasS="text-gray-300 hover:bg-gray-700 hover:text-white group flex items-center px-2 py-2 text-base">{{menuItem.label}}</span>
                        </template>
                    </nav>
                </div>

                <div class="flex-shrink-0 flex bg-gray-700 p-4">
                    <profile :profile="profile"></profile>
                </div>
            </div>

            <div class="flex-shrink-0 w-14">
                <!-- Force sidebar to shrink to fit close icon -->
            </div>
        </div>

        <beta v-if="showBetaHint"/>
    </div>
</template>


<script>
import Icon from '@/Shared/Icon';
import Logo from '@/Shared/Logo';
import Profile from "@/Shared/Profile";
import Beta from "@/Shared/Beta";
import { Link } from '@inertiajs/vue2';

export default {
    components: {
        Icon,
        Logo,
        Profile,
        Link,
        Beta
    },
    props: {
        showUserMenu: {
            Boolean,
            default: false
        },
        menu: Array,
        profile: Object
    },
    methods: {
        showDropdownMenus() {
            this.$emit('showDropdownMenus', true);
        },
        hideDropdownMenus() {
            this.$emit('hideDropdownMenus', true);
        },
        navigateTo(path) {
            this.$emit('navigateTo', path);
        },
        isActive(path) {
            return path && (this.getPath().substring(0, this.route(path).length) === this.route(path));
        },
        getPath() {
            const url = new URL(window.location.href);
            return url.origin + url.pathname;
        },
        menuIconClass(menuItem) {
            let classes = {
                'fill-white' : this.isActive(menuItem.route),
                'fill-gray-300 group-hover:fill-white' : !this.isActive(menuItem.route)
            }
            if(menuItem.hasOwnProperty('iconClass')){
                classes[menuItem.iconClass] = true;
            }
            return classes;
        }
    },
    computed: {
        showBetaHint() {
            return this.$inertia.page.props.tenant.misc.show_beta_hint;
        }
    }
}
</script>
